











































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

import {
  Cell,
  Field,
  Button,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup
} from "vant";
import CustomSelect from "../components/CustomSelect.vue";

const createAccountModule = namespace("createAccount");

@Component({
  name: 'SurveyPageThree',
  components: {
    [Cell.name]: Cell,
    [Field.name]: Field,
    customSelect: CustomSelect,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup
  }
})
export default class SurveyPageThree extends Vue {
  @createAccountModule.Getter("examine_list") examine_list: any;
  financial: any = [];

  handleChangeParentValue() {
    const financial = this.financial.filter(item => {
      return item.type == "multiSelect";
    });
    
    financial[0].options.forEach(option => {
      const children = (option as any).children;
      children && (children.value = "");
    });
  }

  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  get isNextDisabled() {
    const flag = this.financial.some(item => {
      if (item.type === "select") {
        return item.value === "";
      } else if (item.type === "inputCheckbox") {
        if (item.value.length) {
          return (item.value as any).some(key => {
            const option: any = item.options[key - 1];
            if (option.isChecked && !option.inputValue) {
              return true;
            } else {
              return false;
            }
          });
        } else {
          return true;
        }
      } else if (item.type === "multiSelect") {
        if (item.value == "") {
          return true;
        } else {
          const option = item.options.find(option => {
            return (option as any).value == item.value;
          });
          return (option as any).children.value == "";
        }
      } 
    });
    return flag;
  }

  created() {
    this.financial = this.$t("open_account.survey.page_three.financial_list");
  }

  toggleCheckboxInput(item, option) {
    if (option.inputValue !== undefined) {
      const checked = item.value.includes(option.value);
      option.isChecked = checked;
      if (!checked) {
        option.inputValue = "";
      }
    }
  }

  handleNextStep() {
    (this as any).$apis
      .saveExamine({
        examine_list: {
          ...this.examine_list,
          financialSituation: this.financial
        }
      })
      .then(res => {
        this.$router.push({
          path: "/risk-assessment",
          query: this.$route.query
        });
        
      })
      .catch(e => {
        
      });
  }
}
